export function StatCard({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="rounded-card border border-line bg-white p-4">
      <p className="text-sm text-muted">{label}</p>
      <p className="mt-2 text-2xl font-semibold text-ink">{value}</p>
    </div>
  );
}
